exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".daterange-picker[data-v-7d9ac306]{display:inline-block;width:auto;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-7d9ac306&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductReviewDetail.vue
// module id = 919
// module chunks = 2